import {
    useEffect,
    useState,
} from 'react';

import {allComponentsSelector} from '../selectors';

import {useOrganizations} from '../hooks/useOrganizations.ts';
import {Organization} from '../types';
import {FieldProps} from 'formik';
import {useAppSelector} from "../../../../hooks/useTypedReactRedux.ts";
import {
    Autocomplete,
    AutocompleteProps,
    Group,
    Text
} from "@mantine/core";

export const OrganizationsAutocomplete = ({
                                              field,
                                              form,
                                              ...rest
                                          }: FieldProps) => {

    const [value, setValue] = useState<string | undefined>();

    const {
        items: organizations,
        fetchRecords
    } = useOrganizations();


    useEffect(() => {
        fetchRecords({});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const records = useAppSelector((state) => allComponentsSelector(state));

    useEffect(() => {
        const record = records.find((record: Organization) => record.id === field.value);
        if (record) {
            setValue(record.name);
        }
    }, [records, field.value]);


    const renderAutocompleteOption: AutocompleteProps['renderOption'] = ({option}) => {
        const record = organizations.find((record: Organization) => record.name === option.value);
        return (
            <Group gap="sm">
                <div>
                    <Text size="sm">{record.name}</Text>
                </div>
            </Group>
        )
    };


    const data = records.map((record: Organization) => {
        return record.name;
    });

    const handleChange = (value: string) => {
        setValue(value);
        const record = organizations.find((record: Organization) => record.name === value);
        form.setFieldValue(field.name, record.id);
    };

    return (
        <Autocomplete
            name={field.name}
            value={value}
            data={data}
            renderOption={renderAutocompleteOption}
            onChange={handleChange}
            {...rest}
        />
    );
};
